import { ReactElement } from 'react';

import Link from 'next-translate-routes/link';

import { PrismicRichText } from '@prismicio/react';

import { PrismicNextImage } from '@prismic/components/PrismicNextImage';
import { linkResolver } from '@prismic/prismic-config';

import * as SProductList from '@components/organisms/ProductList/styles';
import * as SProductTile from '@components/molecules/ProductTile/styles';
import { IProps } from './types';
import * as S from './styles';

export function SliceLinkedProducts({
  slice: { primary, fields },
}: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-linked-products">
      <S.Title>
        <PrismicRichText field={primary.slicetitle} />
      </S.Title>
      <S.List>
        <SProductList.List loading={false}>
          {fields.slice(0, 4).map((item, i) => (
            <Link href={linkResolver(item.productlink)} key={i}>
              <a>
                <SProductTile.Wrapper data-cy="product-tile">
                  <SProductTile.Image>
                    <PrismicNextImage
                      field={item.productimage}
                      style={{ maxWidth: '100%', height: '100%' }}
                    />
                  </SProductTile.Image>
                  <SProductTile.Bottom>
                    <SProductTile.Title>
                      <PrismicRichText field={item.productname} />
                    </SProductTile.Title>
                    <SProductTile.Price>
                      <PrismicRichText field={item.productprice} />
                    </SProductTile.Price>
                    <SProductTile.Category>
                      <PrismicRichText field={item.productcategory} />
                    </SProductTile.Category>
                  </SProductTile.Bottom>
                </SProductTile.Wrapper>
              </a>
            </Link>
          ))}
        </SProductList.List>
      </S.List>
    </S.Wrapper>
  );
}

SliceLinkedProducts.componentName = 'linkedproducts';
